import React, { useEffect, useState } from 'react'
import {
  Button,
  ButtonGroup,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import SmallModal from '../../../../components/Modals/SmallModal'
import DeleteIcon from '@mui/icons-material/Delete'

const EditCategory = ({
  category,
  data,
  setData,
  onClose,
  setChangesPresent,
}) => {
  const [categoryName, setCategoryName] = useState('')
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false)
  useEffect(() => setCategoryName(category), [category])
  const handleSubmit = (e) => {
    e.preventDefault()
    const updatedData = Object.entries(data).reduce((acc, [key, value]) => {
      if (key === category) {
        acc[categoryName] = value
      } else {
        acc[key] = value
      }
      return acc
    }, {})
    setData(updatedData)
    onClose()
    if (category !== categoryName) setChangesPresent(true)
  }

  const handleDeleteCategory = (e) => {
    e.preventDefault()
    const updatedData = {...data}
    delete updatedData[category]
    setData(updatedData)
    setChangesPresent(true)
    setOpenConfirmDelete(false)
    onClose()
  }
  return (
    <SmallModal open={!!category} onClose={onClose}>
      <Stack
        gap={1}
        component="form"
        onSubmit={handleSubmit}
        alignItems="center"
      >
        <Typography variant="title3">Edit Category Name</Typography>
        <TextField
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
          required
          size="small"
        />
        <Button
          type="submit"
          color="success"
          variant="contained"
          size="small"
          fullWidth
        >
          Submit
        </Button>
        <Stack
          direction="row"
          gap={1}
          alignItems="center"
          marginTop={2}
          sx={{ cursor: 'pointer' }}
          onClick={() => setOpenConfirmDelete(true)}
        >
          <DeleteIcon color="error" fontSize="small" />
          <Typography variant="caption" color="error">
            Delete this Category
          </Typography>
        </Stack>
      </Stack>
      <SmallModal
        open={openConfirmDelete}
        onClose={() => setOpenConfirmDelete(false)}
      >
        <Stack gap={1}>
          <Typography textAlign='center'>Are you sure you want to delete {category}?</Typography>
          <Typography variant="caption" textAlign='center'>
            This will also delete all of its fields and cannot be undone
          </Typography>
          <ButtonGroup orientation='vertical'>
            <Button onClick={handleDeleteCategory} variant='contained' color='error'>Yes - DELETE</Button>
            <Button onClick={() => setOpenConfirmDelete(false)} color='info' variant='outlined'>No - Cancel</Button>
          </ButtonGroup>
        </Stack>
      </SmallModal>
    </SmallModal>
  )
}

export default EditCategory
